export default __webpack_public_path__ + "static/media/hero.565a8c0e.jpg";